<template>
    <div class="theme-default">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    components:{
    },
    mounted () {
    }
};
</script>
<style lang="less">
    *{
        margin: 0;
        padding: 0;
    }
    html,body{
        height: 100%;
        width: 100%;
        overflow-x: auto;
    }
    .theme-default{
        min-width: 1600px;
        height: 100%;
        font-family: Arial, 'Times New Roman', Helvetica;
    }
</style>


